var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_862_3960",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.250977,
    y: 0.5,
    width: 35,
    height: 35.0004,
    rx: 4,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_862_3960)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_862_3960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.251 46.5C32.6104 46.5 44.251 35.0833 44.251 21C44.251 6.91674 32.6104 -4.5 18.251 -4.5C3.89157 -4.5 -7.74902 6.91674 -7.74902 21C-7.74902 35.0833 3.89157 46.5 18.251 46.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1206 21H44.251C44.251 18.6984 43.9382 16.4688 43.3553 14.3478H17.1206V21Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1206 7.69567H40.4349C38.8433 5.14846 36.8083 2.89699 34.4356 1.04346H17.1206V7.69567Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.93309 34.3043H40.4347C41.7125 32.2594 42.7034 30.0242 43.3551 27.6521H-6.85352C-6.20179 30.0242 -5.21084 32.2594 -3.93309 34.3043Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29466 -0.517816H6.66401L4.46011 1.05253L5.30196 3.59346L3.09816 2.02312L0.894351 3.59346L1.62154 1.39837C-0.318914 2.98365 -2.01968 4.84097 -3.42124 6.91045H-2.66206L-4.06495 7.91003C-4.28351 8.26763 -4.49313 8.63091 -4.69402 8.99956L-4.02412 11.0217L-5.27395 10.1311C-5.58463 10.7767 -5.8688 11.4368 -6.12423 12.1107L-5.38617 14.3387H-2.66206L-4.86597 15.9091L-4.02412 18.45L-6.22792 16.8797L-7.54803 17.8204C-7.68016 18.8621 -7.74902 19.9231 -7.74902 21H18.251C18.251 6.91683 18.251 5.25654 18.251 -4.5C13.1148 -4.5 8.3268 -3.03873 4.29466 -0.517816ZM5.30196 18.45L3.09816 16.8797L0.894351 18.45L1.7362 15.9091L-0.467703 14.3387H2.25641L3.09816 11.7978L3.93991 14.3387H6.66401L4.46011 15.9091L5.30196 18.45ZM4.46011 8.48079L5.30196 11.0217L3.09816 9.45139L0.894351 11.0217L1.7362 8.48079L-0.467703 6.91045H2.25641L3.09816 4.36952L3.93991 6.91045H6.66401L4.46011 8.48079ZM14.628 18.45L12.4242 16.8797L10.2204 18.45L11.0623 15.9091L8.85838 14.3387H11.5825L12.4242 11.7978L13.266 14.3387H15.9901L13.7862 15.9091L14.628 18.45ZM13.7862 8.48079L14.628 11.0217L12.4242 9.45139L10.2204 11.0217L11.0623 8.48079L8.85838 6.91045H11.5825L12.4242 4.36952L13.266 6.91045H15.9901L13.7862 8.48079ZM13.7862 1.05253L14.628 3.59346L12.4242 2.02312L10.2204 3.59346L11.0623 1.05253L8.85838 -0.517816H11.5825L12.4242 -3.05875L13.266 -0.517816H15.9901L13.7862 1.05253Z",
    fill: "#0052B4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_862_3960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 51,
    fill: "white",
    transform: "translate(-7.74902 -4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/USD.2170170d0731c42b9e2955e5ef86c92a.svg";
export { ForwardRef as ReactComponent };